// extracted by mini-css-extract-plugin
export default {"style":"AffichageGrapheAutomatiqueXT_style__BiKuf"};